// extracted by mini-css-extract-plugin
export default {"container":"CalendarPanel_container__QrTDS","widgetsContainer":"CalendarPanel_widgetsContainer__I1MTX"};